import { createI18nProperty } from '@/i18n'
import Layout from '../companyAdmin/layout.vue'
import Detail from './detail.vue'
import DashboardIndex from './dashboard'

const basePath = '/v-admin/ap-scheduler'

export default {
  name: 'apSchedulerLayout',
  path: `${basePath}`,
  component: Layout,
  redirect: `${basePath}/index`,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: {
      strict: false,
      any: [
        'PERM_VIEW_INTEGRATION_STATUS_DASHBOARD',
        'PERM_VIEW_INTEGRATION_ERROR_DASHBOARD'
      ]
    },
    titleI18nKey: 'admin.apScheduler.tab.dashboard',
    tab: createI18nProperty({
      contentStyle: {
        background: '#f7f7f7',
        padding: '40px'
      }
    }, 'label', 'admin.apScheduler.tab.dashboard')
  },
  children: [
    {
      name: 'apSchedulerIndex',
      path: `${basePath}/index`,
      component: DashboardIndex,
      meta: {
        titleI18nKey: 'admin.apScheduler.tab.dashboard',
        breadcrumb: { hidden: true }
      }
    },
    {
      name: 'apSchedulerTaskDetail',
      path: `${basePath}/:apSchedulerJobId/detail`,
      component: Detail,
      meta: {
        titleI18nKey: 'admin.apScheduler.tab.detail'
      }
    }
  ]
}
